const clickAway = {
    beforeMount: function (el, binding){
        el.clickAway = function(e){
            if (el.contains(e.target)) return

            if (el.offsetWidth < 1 && el.offsetHeight < 1) return

            if ( typeof binding.value === 'function' ) {
                binding.value();
            } else {
                binding.instance[binding.expression](e);
            }
        }

        document.addEventListener('click', el.clickAway);
    },
    unmounted: function(el){
        document.removeEventListener('click', el.clickAway);
    }
}

export default clickAway;